/**
 * The client-facing product name, in one place.
 *
 * It was written out fifteen times across the app in four different casings — "MUSE EOS",
 * "Muse EOS", "MuseEOS", and a `muse_eos` package name — which is why renaming it is a
 * fifteen-file change instead of a one-line one. Same reason `navLabels.js` exists (#96).
 *
 * Import this rather than typing the name. The logo is the client's symbol-only mark
 * (`/ace-logo.png` on light backgrounds, `/ace-logo-dark.png` on the dark login panel),
 * exported from `docs/ACE Logo-selected/png/` — their SVG/AI files only wrap a raster.
 *
 * ACE is all caps — it is Apple's own acronym, the one in "FY23Q1 ACE Challenge" and
 * "ACE Assessment Program". Not a typo to title-case back to "Ace".
 */
export const BRAND = "ACE Academy";

/**
 * The provider line shown beneath the wordmark: ACE Academy is what Apple's staff use,
 * MUSE is the platform underneath it, AKA is us.
 *
 * Ends in "AKA" rather than "AKA AI" — client branding feedback, 2026-08-12 (#156).
 * The company is AKA; the AI part is what MUSE already conveys.
 *
 * One "by", deliberately — "Powered by MUSE by AKA" makes MUSE read as a sub-brand of
 * whatever is doing the powering. The middle dot attaches the company without a second
 * preposition, and it is punctuation the app already uses (초대 · 권한 관리).
 *
 * Shown beneath the wordmark on the sign-in panel, and once per page in `Footer.js`.
 * Deliberately not in the Navbar: the wordmark there is a link to /, and hanging a second
 * name off it made the header read as though the product were called "ACE Academy Powered
 * by MUSE · AKA".
 *
 * The backend keeps its own copy for the Excel exports (`api/utils/session_export.py`) —
 * a JS constant cannot reach a workbook. Change both together.
 */
export const PROVIDER = "Powered by MUSE · AKA";
